import React from 'react'
import { styled } from 'styled-components'

const Faqs = () => {

  const faqs = [
    {question: 'What is the African Materials Research Society(AMRS)?', answer: 'The African Materials Research Society (AMRS) is an organization of materials researchers and it members that promotes communication for the advancement of interdisciplinary materials research and technology to improve the quality of life.'},
    {question: 'How can I become a member of the (AMRS)?', answer: 'Becoming a member of the Materials Research Society is easy. Simply visit our Membership page and follow the registration process. Membership offers various benefits including access to conferences, journals, networking opportunities, and more.'},
    {question: 'What resources does (AMRS) offer for students and early-career researchers?', answer: '(AMRS) is committed to supporting the next generation of materials researchers. We offer scholarships, awards, mentorship programs, and career development resources specifically tailored for students and early-career researchers.'},
    {question: 'How can I stay updated on (AMRS) news and announcements?', answer: 'Stay informed about AMRS news, upcoming events, and research breakthroughs by subscribing to our newsletter and following us on social media platforms like Twitter, LinkedIn, and Facebook.'},
    {question: 'Can I volunteer or get involved with AMRS activities?', answer: 'Absolutely! AMRS welcomes volunteers who are passionate about materials research. You can contribute by participating in organizing events, reviewing submissions, mentoring, and more. Visit the Volunteer section on our website to learn about available opportunities.'},
    {question: 'Does (AMRS) offer educational resources for the general public?', answer: 'Yes, (AMRS) is dedicated to promoting public understanding of materials science. We provide educational resources, outreach programs, and initiatives to engage the public, students, and educators in the exciting world of materials research.'},
    {question: 'How do I contact (AMRS) for further assistance or inquiries?', answer: "For any questions or inquiries, feel free to reach out to our support team via the Connect page on our website. We're here to assist you with any information you need."},
  ]
  return (
    <Container>
      <h1>FAQS</h1>
      <div className="faqs-wrapper">
        {
          faqs.map((faq, index) => {
            return (<div className="faq-content-container" key={index}>
            <p><span>{index + 1}.</span></p>
            <div className="faq-content-info">
              <h4>{faq.question}</h4>
              <p>{faq.answer}</p>
            </div>
          </div>  )
          })
        }
      </div>
    </Container>
  )
}

const Container = styled.section`
  padding: 5rem 2rem;
  h1{
    font-size: 3rem;
  }
  .faq-content-container{
    border-top: 1px solid var(--color-black);
    padding: 2em 0;
    span{
      font-size: 1.3rem;
      font-weight: bold;
    }
    .faq-content-info{
      h4{
        font-size: 1.2rem;
      }
      p{
        font-size: 1.1rem;
        letter-spacing: 1px;
      }
    }
  }

  /* Media Queries */
  @media only screen and (min-width: 800px){
    padding: 5rem 5rem;
    .faq-content-container{
      .faq-content-info{
      display: flex;
      gap: 5em;
      align-items: center;
      h4{
        width: 30%;
      }
      p{
        width: 70%;
        letter-spacing: 1px;
        line-height: 1.7;
        font-size: 1.2rem;
      }
    }
    }
  }

  @media only screen and (min-width: 1200px){
    padding: 5rem 10rem;
  }
`;

export default Faqs